import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getUserProfile } from './redux/authSlice';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import Messages from './pages/Messages';
import Search from './pages/Search';
import Admin from './pages/Admin';
import FollowersList from './pages/FollowersList';
import FollowingList from './pages/FollowingList';
import Recommendations from './pages/Recommendations';
import Notifications from './pages/Notifications';
import AuthSuccess from './pages/AuthSuccess';
import HashtagPage from './pages/HashtagPage';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector(state => state.auth);

  useEffect(() => {
    if (isAuthenticated && !user) {
      dispatch(getUserProfile());
    }
  }, [dispatch, isAuthenticated, user]);

  return (
    <Router>
      <div className="app">
        {isAuthenticated && <Sidebar />}
        <main className={`app-main ${isAuthenticated ? 'with-sidebar' : ''}`}>
          <Routes>
            <Route path="/auth-success" element={<AuthSuccess />} />
            <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
            <Route path="/register" element={isAuthenticated ? <Navigate to="/" /> : <Register />} />
            <Route path="/" element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
            <Route path="/profile/:userId" element={isAuthenticated ? <Profile /> : <Navigate to="/login" />} />
            <Route path="/edit-profile" element={isAuthenticated ? <EditProfile /> : <Navigate to="/login" />} />
            <Route path="/search" element={isAuthenticated ? <Search /> : <Navigate to="/login" />} />
            <Route path="/hashtag/:hashtag" element={isAuthenticated ? <HashtagPage /> : <Navigate to="/login" />} />
            <Route path="/messages" element={isAuthenticated ? <Messages /> : <Navigate to="/login" />} />
            <Route path="/followers/:userId" element={isAuthenticated ? <FollowersList /> : <Navigate to="/login" />} />
            <Route path="/following/:userId" element={isAuthenticated ? <FollowingList /> : <Navigate to="/login" />} />
            <Route path="/recommendations" element={isAuthenticated ? <Recommendations /> : <Navigate to="/login" />} />
            <Route path="/notifications" element={isAuthenticated ? <Notifications /> : <Navigate to="/login" />} />
            <Route path="/admin" element={isAuthenticated && user?.isAdmin ? <Admin /> : <Navigate to="/" />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
